export const ADDRESS_FINDER_KEY = "addressfinder";
export const BANK_ACCOUNT_KEY = "bankaccount";
export const DATEPICKER_KEY = "datepicker";
export const WHAKAPAPA_KEY = "whakapapa";
